import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import { FadeInUpBig } from "animate-css-styled-components"
import styled from "styled-components"

const Wrapper = styled(FadeInUpBig)`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 14;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
`

export default class Manager extends PureComponent {
  static propTypes = {
    options: PropTypes.array
  }

  state = {
    toggled: false
  }

  render() {
    return (
      <Wrapper {...this.props} duration="0.4s">
        {this.props.children}
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/mobile-menu-manager/mobile-menu-wrapper.component.js